import React from 'react';
import { WixDesignSystemIconThemeProviderProps } from './WixDesignSystemIconThemeProvider.types';
import { IconThemeContext } from './IconThemeContext';
import { defaultIcons } from './defaultIcons';

const WixDesignSystemIconThemeProvider = ({
  children,
}: WixDesignSystemIconThemeProviderProps) => {
  return (
    <IconThemeContext.Provider value={{ icons: defaultIcons }}>
      {children}
    </IconThemeContext.Provider>
  );
};

export { WixDesignSystemIconThemeProvider };
